import {
  Component,
  DoCheck,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { Subscription } from "rxjs";
import { MerchantIdTitle } from "src/app/models/merchantIdTitle";
import { DataExchangeService } from "src/app/services/dataExchange.service";
import { GetMerchantForUserService } from "src/app/services/getMerchantForUser.service";
import { JwtHelperService } from "@auth0/angular-jwt";
import { Router } from "@angular/router";

@Component({
  selector: "app-user",
  templateUrl: "./user.component.html",
  styleUrls: ["./user.component.css"],
})
export class UserComponent implements OnInit, DoCheck {
  // data: Subscription
  @ViewChild("menuRef", { static: false }) menuRef!: ElementRef;

  merchants: MerchantIdTitle[];
  selectedMer: string;

  showMenu: boolean = false;

  template!: TemplateRef<any>;

  constructor(
    private dataEx: DataExchangeService,
    private jwtHelper: JwtHelperService,
    private router: Router
  ) {}

  ngOnInit() {}

  ngDoCheck() {
    const user = this.jwtHelper.decodeToken(localStorage.getItem("token"));
    if (
      user["UserId"] == 1 &&
      this.jwtHelper.isTokenExpired(localStorage.getItem("token"))
    ) {
      this.router.navigateByUrl("");
    }
  }

  onShowMenu(val: boolean) {
    if (val) document.getElementById("scrollable").style.overflow = "hidden";
    else document.getElementById("scrollable").style.overflow = "auto";
    this.showMenu = val;
  }
  onMneuTempateRender(template: TemplateRef<any>) {
    this.template = template;
  }

  onClickOutside(event: Event) {
    // Check if the menu is open
    console.log(
      this.showMenu,
      this.menuRef,
      this.menuRef.nativeElement.contains(event.target)
    );

    if (
      this.showMenu &&
      this.menuRef &&
      !this.menuRef.nativeElement.contains(event.target)
    ) {
      this.showMenu = false;
      document.getElementById("scrollable").style.overflow = "auto";
    }
  }
}
